import GoodProfilesListContainer from "../../../components/commodity-management/GoodProfilesList";

export default function GoodProfiles() {
  return <GoodProfilesListContainer />;
}
